module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('b', [_vm._v("Version")]), _vm._v(" 1.0\n  ")]), _vm._v("\n  Hisana Admin © 2018\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb3f6874!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 1445
// module chunks = 2